import type { ReactNode } from 'react';

import { SorareLogo } from '@sorare/core/src/atoms/icons/SorareLogo';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandT } from '@sorare/core/src/atoms/typography';

type Props = { title?: ReactNode };
export const SeriesOnboardingHeader = ({ title }: Props) => {
  return (
    <Vertical center gap={2}>
      <SorareLogo size="mediumLarge" />
      {!!title && <BrandT>{title}</BrandT>}
    </Vertical>
  );
};
